export default __webpack_public_path__ + "static/media/craon34.037c74fe.jpg";